/**
 * useBackToDashboard — the Back action for a page that leads off the Dashboard (Chat,
 * the Run map).
 *
 * Back steps back through history, so Android's back gesture on the Dashboard doesn't
 * reopen the page. A cold start on the page has nothing in the app behind it (React
 * Router's "default" key), so it swaps itself for the Dashboard.
 */

import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export function useBackToDashboard(): () => void {
  const navigate = useNavigate();
  const { key: locationKey } = useLocation();

  return useCallback(() => {
    if (locationKey === 'default') navigate('/dashboard', { replace: true });
    else navigate(-1);
  }, [locationKey, navigate]);
}
